<template>
  <div>
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Pharmacy User</h3>
        <h5>These users can accesss multiple pharmacies. All others can only access their assigned pharmacy.</h5>
        <table class="Customer-table DisplayTable">
          <thead>
              <tr>
                <th>User</th>
                <th>Pharmacy</th>
                <th>Enabled</th>
                <th class="buttonCol" />
              </tr>
            </thead>
            <tbody>
              <tr height="30px">
                <td class="Customer-table-cell">
                  <input type="text" 
                    v-model="userEmail" 
                    placeholder="Users email address"  
                    class="CustomerName"
                    @change="validateUserEmail(userEmail.toLowerCase())">
                </td>
                 <td class="pharmacyUser">
                   <span v-for="index in NewPharmacies" :key="index">
                    <select v-model="NewPharmacies[index]" 
                      class="CustomerName chargeTo" 
                      @change="allDataEntered(userEmail.toLowerCase(),NewPharmacies[index]), AddPharmacy(null,NewPharmacies[index])">
                    <option value="" disabled hidden>Select Pharmacy</option>
                    <option
                      v-for="Pharmacy in sortedPharmacies"
                      v-bind:value="Pharmacy.code"
                      v-bind:key="Pharmacy.id"
                      >
                      {{Pharmacy.code}}
                    </option>
                  </select>
                  </span>
                <td class="Pharmacy-table-cell">
                  <input
                    v-model="enabled"
                    type="checkbox"
                    readonly="readonly">
                </td>
                <td v-if="editingId != null" class="Pharmacy-table-cell" >
                  <button class="addrecordbutton icon btnDisabled" hidden></button>
                </td>
                <td v-else-if="validEmail && AllData && editingId === null" class="product-table-cell center" >
                  <button v-on:click="createPharmacyUser(userEmail.toLowerCase(), enabled)" class="addrecordbutton icon" title="Add Pharmacy"></button>
                </td>
                <td v-else class="Pharmacy-table-cell">
                  <button class="addrecordbutton icon btnDisabled" title="Not all data has been entered to add record" disabled></button>
                </td>
              </tr>

              <tr v-for= "(PharmacyUser, indexUser) in frozenPharmacyUsers" :key="indexUser" height="30px" data-is-editable="0">
                <td class="Pharmacy-table-cell" >
                  <input type="text"
                    v-model="PharmacyUser.userEmail"
                    :readonly="editingId == indexUser ? false : true"
                    :class="editingId == indexUser ? 'CustomerName editable' :'CustomerName'"
                    @change="validateUserEmail(PharmacyUser.userEmail.toLowerCase(), 'update')">
                </td>
                <td class="pharmacyUser">
                    <span v-for= "(PharmacyCode, indexPharmacy) in PharmacyUser.pharmacyCodes" :key="indexPharmacy">
                      <select v-model= "PharmacyUser.pharmacyCodes[indexPharmacy]" 
                        :class="editingId == indexUser ? 'CustomerName chargeTo editable' : 'CustomerName chargeTo'"
                        @change="ChangePharmacy(indexPharmacy, PharmacyUser.pharmacyCodes[indexPharmacy])"
                        :disabled="editingId == indexUser ? false : true"
                        >
                        <option
                          v-for="Pharmacy in sortedPharmacies"
                          v-bind:value="Pharmacy.code"
                          v-bind:key="Pharmacy.id"
                          >
                          {{Pharmacy.code}}
                        </option>
                      </select>
                      <button class="minusbutton" v-if="editingId == indexUser" v-on:click="RemovePharmacy(indexUser, indexPharmacy)"></button>
                    </span>
                    <span v-if="pharmacyUser.length === 0" class="pharmacyUser">
                      <button v-if="editingId === indexUser" class="plusbutton" v-on:click="AddPharmacy(indexUser)"></button>
                      <button v-else class="plusbutton" hidden></button>
                    </span>
                </td>

                <td class="Pharmacy-table-cell">
                  <input type="checkbox"
                    v-model="PharmacyUser.enabled"
                    :disabled="editingId == indexUser ? false : true"
                    :class="editingId == indexUser ? 'editable' :''" >
                </td>
                <td class="Pharmacy-table-cell">
                    <span v-if="editingId === null">
                      <button v-on:click="editItem(indexUser)" class="editbutton icon" title="Edit User"></button>
                      <button v-on:click="deletePharmacyUser(PharmacyUser.id, PharmacyUser.userEmail.toLowerCase())" class="deletebutton icon" title="Delete User"></button>
                    </span>
                    <span v-else-if="editingId === indexUser">
                      <span v-if="AllData && validEmail">
                        <button v-on:click="updatePharmacyUser(PharmacyUser.id, PharmacyUser.userEmail.toLowerCase(), PharmacyUser.enabled)" class="savebutton icon" title="Save"></button>
                      </span>
                      <span v-else>
                         <button disabled class="savebutton icon btnDisabled" title="Not all data has been entered to save record"></button>
                     </span>
                        <button v-on:click="canceledit(indexUser)" class="cancelbutton icon" title="Cancel"></button>
                    </span>
                    <span v-else>
                      <button class="editbutton icon" hidden></button>
                      <button class="deletebutton icon" hidden></button>
                    </span>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>
    <div v-if="message" class="errormessage">
      <table>
        <tr>
          <td>{{message}}</td>
        </tr>
      </table>
    </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { listPharmacyUsers } from '../graphql/queries';
import { getPharmacyUserByUserEmail } from '../graphql/queries';
import { listPharmacys } from '../graphql/queries';
import { createPharmacyUser } from '../graphql/mutations';
import { updatePharmacyUser } from '../graphql/mutations';
import { deletePharmacyUser } from '../graphql/mutations';
import { onCreatePharmacyUser } from '../graphql/subscriptions';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";

export default {
  name: 'app',
  components:{
    RwvMenu,
  },
  async created() {
  // console.log("created ...")
    this.listPharmacyUsers();
    this.listPharmacies();
    this.subscribeCreate();
    this.NewPharmacies.push("");
    },
    data() {
      return {
        PharmacyUsers: [],
        frozenPharmacyUsers: [],
        Pharmacies: [],
        editingId: null,
        userEmail: '',
        pharmacy: [],
        NewPharmacies:[],
        TempPharmacies:[],
        enabled: true,
        pharmacyUser: [],
        id:'',
        editUser: '',
        UserValid: false,
        message: '',
        AllData: false,
        validEmail: false,
        currentSort: 'email',
        currentSortDir: 'asc',
        searchValue: '',
      }
  },
   computed: {
    sortedPharmacyUsers: function() {
  //    console.log('sortedPharmacyUsers ...');
  
      if (this.editingId != null) {return this.frozenPharmacyUsers}
      return this.PharmacyUsers.slice().sort((a,b) => {
        if(a["userEmail"] === null | a["userEmail"] === undefined) return 1;
        if(b["userEmail"] === null | b["userEmail"] === undefined) return -1;
        if(a["userEmail"].toLowerCase() < b["userEmail"].toLowerCase()) return -1;
        if(a["userEmail"].toLowerCase() > b["userEmail"].toLowerCase()) return 1;
        return 0;
        });
    },
    sortedPharmacies: function() {
      // console.log('sortedPharmacies ...');
      return this.Pharmacies.slice().sort((a,b) => {

        if(a["code"] === null | a["code"] === undefined) return 1;
        if(b["code"] === null | b["code"] === undefined) return -1;
        if(a["code"].toLowerCase() < b["code"].toLowerCase()) return -1;
        if(a["code"].toLowerCase() > b["code"].toLowerCase()) return 1;
        return 0;
      });
    },

    searchPharmacyUsers() {
        let tempPharmacyUsers = this.PharmacyUsers
        
        if (this.searchValue != '' && this.searchValue) {
              tempPharmacyUsers = tempPharmacyUsers.filter((item) => {
                return item.PharmacyUsers.email
                  .toUpperCase()
                  .includes(this.searchValue.toUpperCase())
              })
            }
        return tempPharmacyUsers
      }
  },
  watch: {
    sortedPharmacyUsers: {
      handler: function() {
        if (this.editingId === null) {
          this.frozenPharmacyUsers = this.sortedPharmacyUsers.slice()
        }
      }     
    }
  },
  methods: {
    reset(){
      Object.assign(this.$data, this.$options.data.apply(this));
      this.listPharmacyUsers();
      this.listPharmacies();

    },
    async listPharmacyUsers() {
      // console.log("listPharmacyUsers ...")
      try {
        var limit = 1000;
        const PharmacyUsers = await API.graphql({
          query: listPharmacyUsers,
          variables: {limit: limit}
      });
      this.PharmacyUsers = PharmacyUsers.data.listPharmacyUsers.items;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
      // console.log('listPharmacyUsers end')
    },
    async listPharmacies() {
      // console.log("listPharmacies ...")
      try {
        var limit = 1000;
        const Pharmacies = await API.graphql({
          query: listPharmacys,
          variables: {limit: limit}
        });
        this.Pharmacies = Pharmacies.data.listPharmacys.items;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
      // console.log('listPharmacies end')
    },
                                                                // Create User
    async createPharmacyUser(userEmail, enabled) {
//       console.log("createPharmacyUser ...")
    if (!userEmail ) return;

    var i;
    var n = this.pharmacyUser.length - 1;
    for (i = n; i >= 0; i--) {
    if(this.pharmacyUser[i].name == "" | this.pharmacyUser[i].name == undefined ) {
        this.pharmacyUser.splice(i,1)
      }
    }
    n = this.NewPharmacies.length - 1;
    for (i = n; i >= 0; i--) {
    if(this.NewPharmacies[i] == "" ) {
        this.NewPharmacies.splice(i,1)
      }
    }

    var UpdateValues;
    var pharmacyCodes = this.NewPharmacies.sort();
    UpdateValues = {userEmail, pharmacyCodes, enabled};

    try {
      await API.graphql({
        query: createPharmacyUser,
        variables: {input: UpdateValues},
      });
                                                                // Reset variables
      this.resetVariables();
    }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
//      console.log('createPharmacyUser end ...');
    },
    async validateUserEmail(userEmail){
//      console.log("validateUserEmail ...")
      this.message='';
      this.validEmail = false;
      var xssTest = new RegExp('.+@.+((.co.nz$)|(.nz$)|(.com$))', 'g');
      var notOK = xssTest.exec(userEmail);
      if (notOK === null) {
        this.message = "Invalid email entered"
        return;
      }
      if(userEmail != this.editUser){
        try {
          const PharmacyUser = await API.graphql({
              query: getPharmacyUserByUserEmail,
              variables: {userEmail: userEmail}
          });
          var pharmacyUser = PharmacyUser.data.getPharmacyUserByUserEmail.items;
          if (pharmacyUser[0]){
            this.message = "This user email already exists";
            return;
        }
        }
        catch (error) {
          this.message = commonFunctions.displayError(error);
          return;
        }
      }
      this.validEmail = true;
//      console.log("validateUserEmail end")
    },
    
                                                              // Update view on create
    subscribeCreate () {
      // console.log('subscribeCreate ...')
      API.graphql({
      query: onCreatePharmacyUser
      })
      .subscribe ({
        next: (items) => {
          const pharmacyUser = items.value.data.onCreatePharmacyUser;
          if (this.PharmacyUsers.some(item => item.userEmail.toLowerCase() === pharmacyUser.userEmail.toLowerCase())) return; // remove duplications
          this.PharmacyUsers = [...this.PharmacyUsers, pharmacyUser];
        }
      })
      // console.log('subscribeCreate end')
      },
      
                                                              // Update Contracts
    async updatePharmacyUser(id, userEmail, enabled) {
//       console.log('updatePharmacyUser ...')
      if (!userEmail) return;

      try {
        var UpdateValues;
        var pharmacyCodes = this.TempPharmacies.sort();
        UpdateValues = { id, userEmail, pharmacyCodes, enabled};
        await API.graphql({
          query: updatePharmacyUser,
          variables: {input: UpdateValues},
        });
        this.resetVariables();
        this.editingId = null;
        this.$forceUpdate();
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
//       console.log('updatePharmacyUser end');
    },
                                                                // Delete Contracts
    async deletePharmacyUser(id, userEmail) {
//       console.log('deletePharmacyUser ...');
      if(confirm("Do you really want to delete User (" + userEmail + ")?")) {
        try {
          const deleteItem = {id};
          await API.graphql({
            query: deletePharmacyUser,
            variables: {input: deleteItem},
          });
          this.listPharmacyUsers()
        }
        catch (error) {
          this.message = commonFunctions.displayError(error);
        }
      }
//       console.log('deletePharmacyUser end');
    },
                                                                // set row in edit mode
    editItem(indexRow) {
//      console.log('editItem ...');
       this.message="";
      if (this.frozenPharmacyUsers[indexRow].pharmacyCodes) {
        this.TempPharmacies = Array.from(this.frozenPharmacyUsers[indexRow].pharmacyCodes)
      }
      this.resetVariables();
      this.editingId = indexRow;
      this.AllData = true;
      this.validEmail = true;
      this.editUser = this.frozenPharmacyUsers[indexRow].userEmail.toLowerCase();
//      console.log('editItem end');
    },
                                                                // Reset row to original values
    canceledit(indexRow) {
//      console.log('Cancel Edit ...');
      this.message="";
      var i;
      i = this.frozenPharmacyUsers[indexRow].pharmacyCodes.length - 1;
      for (i; i >= 0; i--) {
        if (this.frozenPharmacyUsers[indexRow].pharmacyCodes[i] == "" || this.frozenPharmacyUsers[indexRow].pharmacyCodes[i] == undefined){
          this.frozenPharmacyUsers[indexRow].pharmacyCodes.splice(i,1)
        }
      }
      this.$forceUpdate();
      this.resetVariables();
      this.editingId = null;
      this.reset();
      this.NewPharmacies.push("")
//      console.log('Cancel Edit end');
    },

    AddPharmacy(indexItem, pharmacy) {
 //     console.log('AddPharmacy ...');
      if(indexItem !== null && indexItem !== undefined && indexItem !== "") {
        if(this.frozenPharmacyUsers[indexItem].pharmacyCodes) {
          const NumAttributes = this.frozenPharmacyUsers[indexItem].pharmacyCodes.length
          this.frozenPharmacyUsers[indexItem].pharmacyCodes.splice(NumAttributes, 0 , "")
        }
        else {
          this.frozenPharmacyUsers[indexItem].pharmacyCodes = new Array
          this.frozenPharmacyUsers[indexItem].pharmacyCodes.push("")
        }
        this.TempPharmacies = Array.from(this.frozenPharmacyUsers[indexItem].pharmacyCodes)
      }
      else {
        if(this.NewPharmacies.length > 0){
          this.NewPharmacies[this.NewPharmacies.length] = pharmacy;
          
        }
        else{
          this.NewPharmacies[0]=this.pharmacy;
          this.NewPharmacies.push("");
        }
      }

      this.$forceUpdate();
//      console.log('AddPharmacy end');
    },

    ChangePharmacy(indexItem, Pharmacy){
 //     console.log('ChangePharmacy ...');
      this.TempPharmacies[indexItem] = Pharmacy;
//      console.log('ChangePharmacy end');
    },

    RemovePharmacy(indexItem, indexRow) {
      // console.log('RemovePharmacy ...');
      this.TempPharmacies.splice(indexRow,1);
      this.frozenPharmacyUsers[indexItem].pharmacyCodes.splice(indexRow,1);
      // console.log('RemovePharmacy end');
    },
    allDataEntered(userEmail, pharmacy){
//      console.log ("allDataEntered ...");
      this.AllData = false;
      if (!userEmail || !pharmacy){
        this.AllData = false;}
      else {
        this.AllData = true;}
//      console.log ("allDataEntered end");
      },
    resetVariables() {
//      console.log ("resetVariables ...");
      this.userEmail = '';
      this.pharmacy = '';
      this.validEmail = false;
      this.AllData = false;
      this.NewPharmacies = [];
      this.NewPharmacies.push("")
//      console.log ("resetVariables end");
      },
 
      },
    sort: function(s) {
  //     console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },
}
</script>
<style>

</style>
